/*** IMPORTS FROM imports-loader ***/
var define = false;

export default function minTranslate() {
  return -this.snapGrid[0];
}
